import RouteWatcher from './RouteWatcher'

export default RouteWatcher;